import React from 'react';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { Settings2 } from 'lucide-react';

interface ColumnSelectorProps {
  allColumns: string[];
  visibleColumns: string[];
  columnAliases?: Record<string, string>;
  onColumnToggle: (column: string) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

const ColumnSelector: React.FC<ColumnSelectorProps> = ({
  allColumns,
  visibleColumns,
  columnAliases,
  onColumnToggle,
  onSelectAll,
  onDeselectAll,
}) => {
  const getColumnDisplay = (column: string) => {
    return columnAliases?.[column] || column;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8">
          <Settings2 className="h-4 w-4 mr-2" />
          Columns ({visibleColumns.length}/{allColumns.length})
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 max-h-96 overflow-y-auto">
        <DropdownMenuLabel>Toggle Columns</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <div className="px-2 py-1.5">
          <div className="flex gap-2">
            <Button
              variant="ghost"
              size="sm"
              className="h-7 text-xs flex-1"
              onClick={(e) => {
                e.preventDefault();
                onSelectAll();
              }}
            >
              Select All
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="h-7 text-xs flex-1"
              onClick={(e) => {
                e.preventDefault();
                onDeselectAll();
              }}
            >
              Clear
            </Button>
          </div>
        </div>
        <DropdownMenuSeparator />
        {allColumns.map((column) => (
          <DropdownMenuCheckboxItem
            key={column}
            checked={visibleColumns.includes(column)}
            onCheckedChange={() => onColumnToggle(column)}
            className="cursor-pointer"
          >
            <span className="truncate" title={getColumnDisplay(column)}>
              {getColumnDisplay(column)}
            </span>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ColumnSelector;